function cartesianProductOf<V>(values: V[][]) {
  return values.reduce<V[][]>(
    function (a, b) {
      return a
        .map(function (x) {
          return b.map(function (y) {
            return x.concat([y])
          })
        })
        .flat()
    },
    [[]],
  )
}

export default cartesianProductOf
